import { createContext } from "react";
import { Questionnaire } from "@r6digital/rapidstor-types/types/Questionnaire";

export interface QuestionnaireContextProps {
  questionnaire: Questionnaire;
}

export default createContext<Partial<QuestionnaireContextProps>>({});
